import { type ReactNode } from 'react';

import styles from './PublisherDesktopLayout.css';

type TPublisherDesktopLayoutProps = {
  publisher: ReactNode;
  controls: ReactNode;
  vas: ReactNode;
};

export function PublisherDesktopLayout({ publisher, controls, vas }: TPublisherDesktopLayoutProps): ReactNode {
  return (
    <div className={styles['container']} data-testid="publisher.desktop-layout">
      <div className={styles['content']}>
        <div className={styles['publisher']}>{publisher}</div>
        <div className={styles['controls-wrapper']}>{controls}</div>
      </div>
      <div className={styles['vas']}>{vas}</div>
    </div>
  );
}
